/** @jsxImportSource @emotion/react */
import React, { useEffect, useRef, useState } from 'react';
import { useCommonModal } from 'hooks/useCommonModal';
import { useMessageBar } from 'hooks/useMessageBar';
import { useTranslation } from 'react-i18next';
import { Code } from 'models/common/CommonCode';
import { AsstRvwType, IdleAssetCondition } from '../../models/asst/IdleAsset';
import IdleAssetEquipmentGrid from './management/IdleAssetEquipmentGrid';
import { useLocation } from 'react-router-dom';
import IdleAssetRequestInfo from './management/IdleAssetRequestInfo';
import { ManagementMode } from '../../models/common/Common';

interface PageLocationState {
  rvwReqId?: string;
  asstTpCd?: string;
  mode?: ManagementMode;
}
/**
 * 불용자산 검토요청 회신
 * @constructor
 * -------------------------------------------------------------------------------------
 *  Date.       author         Description
 * -------------------------------------------------------------------------------------
 * 2025.10.27  sungim.kim2    최초생성
 */
const IdlAssetReviewReplyPage = () => {
  const { t } = useTranslation();
  // const { openMessageBar } = useMessageBar();
  //const { openCommonModal } = useCommonModal();
  //const [code, setCode] = useState<any>();
  //const [asstRvwRltDivsCd, setAsstRvwRltDivsCd] = useState<Code[]>([]);

  // dataSet
  //const [isAsstMstComplete, setAsstMstComplete] = useState<boolean>(false);

  /* 불용자산 리스트 start  */
  const equipRef = useRef<any>();
  const infoRef = useRef<any>();

  // 목록에서 받아오는 경우 자산요청번호
  const locationState: PageLocationState = useLocation().state;
  const [condition, setCondition] = useState<IdleAssetCondition>({});

  useEffect(() => {
    if (!locationState?.rvwReqId) return;
    if (condition.rvwReqId !== locationState.rvwReqId) {
      const initialCondition = {
        rvwReqId: locationState.rvwReqId,
        asstTpCd: locationState?.asstTpCd,
      };
      setCondition(initialCondition);
      const timer = setTimeout(() => {
        infoRef.current?.search(initialCondition);
      }, 0); // 마운트 이후 실행
      return () => clearTimeout(timer);
    }
  }, [locationState?.rvwReqId]);

  useEffect(() => {
    //console.log('main', condition);
    equipRef.current?.search(condition);
  }, [condition]);

  const handleConditionChange = (newCondition: Partial<IdleAssetCondition>) => {
    setCondition(newCondition);
  };

  return (
    <>
      {/* 요청정보 view */}
      <IdleAssetRequestInfo
        ref={infoRef}
        openMode={AsstRvwType.REPLY}
        condition={condition}
        handleConditionChange={handleConditionChange}
      />

      {/* 설비,기타자산 리스트 */}
      <IdleAssetEquipmentGrid
        ref={equipRef}
        gridHeight={400}
        openMode={
          // locationState?.mode === ManagementMode.READ ? AsstRvwType.READ : AsstRvwType.REPLY
          AsstRvwType.REPLY
        }
        condition={condition}
        onClikDetail={(item) => {
          // reviewRef.current?.search(item);
        }}
        onRefresh={() => {
          // 법인별 검토 현황 재조회 1223 d  dd kdljskj
          const updatedCondition = { ...condition, condition };
          equipRef.current?.search(updatedCondition);
          const initialCondition = {
            rvwReqId: locationState.rvwReqId,
            asstTpCd: locationState?.asstTpCd,
            refresh: true,
          };
          infoRef.current?.search(initialCondition);
        }}
      />
    </>
  );
};

export default IdlAssetReviewReplyPage;
